module.exports = __webpack_public_path__ + "static/media/ch.987cb82c.svg";